import React, {useEffect, useState} from 'react'
import {useHistory} from 'react-router-dom'
import DesignExterno from '../../components/DesignExterno/DesignExterno'
import {useDispatch, useSelector} from 'react-redux'
import {State} from '../../reducers'
import {OLVIDO_PASS_TYPES} from '../../constants/olvidoPass.types'
import SecondaryMail from '../../media/felsv/SecondaryUser.svg'
import SecondaryPhone from '../../media/felsv/SecondaryPhone.svg'
import DarkPhone from '../../media/felsv/DarkPhone.svg'
import DarkMail from '../../media/felsv/DarkUser.svg'
import InputIcon from '../../components/Inputs/InputIcon'
import {bindActionCreators} from 'redux'
import {actionsOlvidoPass, actionsValidacionesOlvidoPass} from '../../actions/action-creators'
import {
  olvidoPassClear,
  olvidoPassFormRestablecerHandleChange,
} from '../../actions/OlvidoPass/olvidoPass.actions'
import {DICCIONARIO} from '../../constants/Diccionario'

const RestablecerEmail = () => {
  const [disable, setDisable] = useState(true)
  const history = useHistory()
  const form = useSelector((state: State) => state.olvidoPass.formRestablecer)
  const dispatch = useDispatch()
  const actionsOP = bindActionCreators(actionsOlvidoPass, dispatch)
  const validacionesOP = bindActionCreators(actionsValidacionesOlvidoPass, dispatch)

  useEffect(() => {
    localStorage.removeItem(OLVIDO_PASS_TYPES.KEY_EMAIL)
    dispatch(olvidoPassClear())
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (form.email && !form.error) setDisable(false)
    else setDisable(true)
  }, [form])

  const sendMail = async (e: any) => {
    e.preventDefault()
    if (await validacionesOP.opValidacionesFormRestablecerEnviar()) return
    if (await actionsOP.olvdioPassFormRestablecerSend()) history.push('/verify')
  }

  const regresar = () => {
    if (form.tipo === OLVIDO_PASS_TYPES.INPUT_EMAIL) return history.push('/')
    dispatch(
      olvidoPassFormRestablecerHandleChange({tipo: OLVIDO_PASS_TYPES.INPUT_EMAIL, telefono: ''})
    )
  }
  
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
    actionsOP.olvidoPassFormRestablecerHandleChangeInput(e)
    validacionesOP.opValidacionesOnBlurFormRestablecer(e)
  }

  return (
    <DesignExterno
      title={
        <span>
          Bienvenido a <span style={{color: '#019FC5'}}>FELes APP</span>
        </span>
      }
    >
      <div className='centrar-horizontal'>
        <section className='wf-section' style={{margin: '0 5%', width: '100%', maxWidth: '500px'}}>
          <div className='w-form' style={{marginBottom: '5%'}}>
            <button onClick={regresar} className='back-button w-inline-block'></button>
            <form
              className='form-content'
              data-wf-page-id='64af1b12915ad23f033d386b'
              data-wf-element-id='ac417b8a-12e2-2eb3-27e8-231ec1120128'
              onSubmit={sendMail}
            >
              <div>
                <h2 className='h2-titles'>Restablece tu contraseña</h2>
                <div>
                  Se enviará un enlace al correo electrónico ingresado para recuperar tu contraseña.
                </div>
              </div>
              <div className='form-separator'></div>
              {form.tipo === OLVIDO_PASS_TYPES.INPUT_EMAIL ? (
                <>
                  <div>
                    <label htmlFor='email' className='field-label m'>
                      {DICCIONARIO.USERNAME}
                    </label>
                    <InputIcon
                      secondaryIcon={SecondaryMail}
                      darkIcon={DarkMail}
                      type='text'
                      maxLength={20}
                      name='email'
                      data-name='email'
                      placeholder={DICCIONARIO.USERNAME}
                      id='email'
                      autoFocus
                      value={form.email}
                      onChange={handleChange}
                      onBlur={validacionesOP.opValidacionesOnBlurFormRestablecer}
                    />
                    {form.error && <p className='alert s'>{form.error}</p>}
                  </div>
                </>
              ) : (
                <div>
                  <label htmlFor='telefono' className='field-label m'>
                    Número de teléfono celular
                  </label>
                  <InputIcon
                    secondaryIcon={SecondaryPhone}
                    darkIcon={DarkPhone}
                    type='tel'
                    maxLength={45}
                    minLength={8}
                    name='telefono'
                    data-name='telefono'
                    placeholder='(+503)'
                    id='telefono'
                    value={form.telefono}
                    onChange={handleChange}
                    onBlur={validacionesOP.opValidacionesOnBlurFormRestablecer}
                  />
                  {form.error && <p className='alert s'>{form.error}</p>}
                </div>
              )}
              <div className='m buttons-div'>
                <button type='submit' className='m button w-inline-block' disabled={disable}>
                  Continuar
                </button>
              </div>
            </form>
          </div>
        </section>
      </div>
    </DesignExterno>
  )
}

export default RestablecerEmail
